/* eslint-disable react/prop-types */
import type { UrlCell } from '../types'
import clsx from 'clsx'
import { createRenderer } from './renderer'

export const Link = createRenderer<UrlCell>({
  View: ({ className, cell }) => {
    return (
      <a
        className={clsx(className, 'focus-within:outline-none', { 'computed-cell': cell.computed })}
        href={cell.value ?? '#'}
        target="_blank"
        rel="noreferrer"
      >
        {cell.label ?? cell.value}
      </a>
    )
  },
  Editor: ({ className, cell, onCellChange, ...props }) => {
    return (
      <input
        type="text"
        value={cell.value ?? ''}
        onChange={(e) =>
          onCellChange?.(props.row, {
            type: 'url',
            value: e.target.value,
          })
        }
        className={clsx(className, { 'computed-cell': cell.computed })}
      />
    )
  },
})
